import React, { Component } from 'react';
import { SHCard, isCardShowStyleList } from './lib/SHCard/SHCard';
import utils from '../../utils/utils';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import './style.less';

class PipelineRecommend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommends: [],
      hasMore: true,
      listHeight: 600,
    };

    this.refreshHideTimer = null;
    this.masonry = null;
    this.MasonryClass = null;
    this.containerRef = null;
    this.scrollerViewRef = null;
    this.isAndroid = utils.isAndroid();
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const { recommends } = this.props;
      this.setState({
        recommends,
      }, () => {
        if (this.state.recommends.length > 0) {
          this.updateMasonryLayout(true, this.state.recommends.length);
        }
      });
      window.addEventListener('resize', this.updateListHeight, false);

      this.addEventListenerKFemaleUpdatePraiseCountChange();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.recommends) !== JSON.stringify(this.props.recommends) || nextProps.loadMoreData) {
      const addedCount = Array.isArray(nextProps.recommends)
        ? nextProps.recommends.length
        : 0;
      const newRecommends = nextProps.isRefreshing
        ? nextProps.recommends
        : [...this.state.recommends, ...nextProps.recommends];

      this.setState(prevState => ({
        recommends: newRecommends
      }), () => {
        if (this.state.recommends.length > 0) {
          this.updateMasonryLayout(nextProps.isRefreshing, addedCount);
        }
        if (nextProps.loadMoreData) {
          this.props.resetLoadMoreData();
        }
      });
    }
    if (!nextProps.hasMore) {
      const opacity = this.scrollerViewRef.style.opacity;
      if (opacity == 0) {
        this.scrollerViewRef.style.opacity = 1
      }
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateListHeight, false);
    }

    if (this.refreshHideTimer) {
      clearTimeout(this.refreshHideTimer);
      this.refreshHideTimer = null;
    }

    if (this.masonry) {
      this.masonry.destroy();
      this.masonry = null;
    }
  }

  // 监听二级笔记详情页面广播来的点赞消息（用于更新对应清单卡片的点赞状态）
  addEventListenerKFemaleUpdatePraiseCountChange = (item, index) => {
    window.Jockey.on('eventCallBack', (data) => {
      if (!this.isAndroid) {
        const { eventName, body = {} } = data || {};
        if (
          eventName === 'kFemaleUpdatePraiseCountChange' &&
          body &&
          body.type
        ) {
          this.updatePraiseStatus(body);
        } 
      } else {
        if (data && data.nameValuePairs) {
          const { eventName, body = {} } = data.nameValuePairs;
          if (
            eventName === 'kFemaleUpdatePraiseCountChange' && 
            body &&
            body.nameValuePairs &&
            body.nameValuePairs.type
          ) {
            this.updatePraiseStatus(body.nameValuePairs);
          }
        }
      }
    });
  }

  // 更新清单卡片的点赞状态
  updatePraiseStatus = ({ type, count, token, id } = {}) => {
    const { recommends } = this.state;
    const newRecommends = recommends.map((item) => {
      if (String(item.note_id) === String(id)) {
        return {
          ...item,
          praiseNum: count,
          isPraise: type === 'add',
        };
      }
      return item;
    });
    this.setState({
      recommends: newRecommends,
    });
  }

  updateMasonryLayout = (isRefreshing = false, addedCount = 0) => {
    if (!this.scrollerViewRef) {
      return;
    }

    const doLayout = () => {
      if (!this.masonry) {
        this.masonry = new this.MasonryClass(this.scrollerViewRef, {
          itemSelector: '.goods-card', // 要布局的网格元素
          fitWidth: true, // 设置网格容器宽度等于网格宽度
          gutter: 9,
          transitionDuration: 0,
        });
        if (this.scrollerViewRef) {
          this.scrollerViewRef.style.opacity = 1;
        }
      } else {
        if (isRefreshing || !addedCount) {
          this.masonry.reloadItems();
          this.masonry.layout();
        } else {
          const allItems = this.scrollerViewRef.querySelectorAll('.goods-card');
          const newElems = Array.prototype.slice.call(allItems, -addedCount);
          if (newElems && newElems.length) {
            this.masonry.appended(newElems);
          }
          this.masonry.layout();
        }
      }
    };

    if (this.MasonryClass) {
      doLayout();
      return;
    }

    import('masonry-layout').then((Masonry) => {
      this.MasonryClass = Masonry;
      doLayout();
    });
  }

  updateListHeight = () => {
    if (this.containerRef) {
      const height = this.containerRef.clientHeight;
      if (height && height !== this.state.listHeight) {
        this.setState({ listHeight: height });
      }
    } else if (typeof window !== 'undefined') {
      const height = window.innerHeight;
      if (height && height !== this.state.listHeight) {
        this.setState({ listHeight: height });
      }
    }
  }

  getTrackData(item, index) {
    const { goods_id, style_id, sku_id, goods_sku_id } = item;
    const options = {
      sort: index,
      name: item.name,
      goods_id,
      style_id,
      sku_id,
      goods_sku_id
    };
    return options;
  }

  render() {
    const { recommends } = this.state;
    const { isLogin, showEmpty, pageOptions = {} } = this.props;
    return (
      <div className="pipeline-recommend" ref={ref => { this.containerRef = ref; }}>
        <div
          ref={ref => this.scrollerViewRef = ref}
          className='scroller-container'
          style={{
            margin: showEmpty ? `0` : '0 12px'
          }}
        >
          {
            recommends && recommends.length > 0 && recommends.map((item, index) => {
              const { component, item_type, price_datas = [], v_datas = [] } = item;
              const price_label_text = price_datas.map(item => item && item.item_datas && item.item_datas[0] && item.item_datas[0].text).filter(Boolean).join(',') || '';
              const tag_label_text = v_datas.map(item => item && item.item_datas && item.item_datas[0] && item.item_datas[0].text).filter(Boolean).join(',') || '';
              let biz = {
                goods_id: item.goods_id,
                style_id: item.style_id,
                set_id: pageOptions['collectionId'],
                type: item_type == 'COLLECTION_NOTE_CARD' ? 'note' : 'goods',
                component,
                price_label_text,
                tag_label_text
              }
              let track_fields = {};
              if (item.track_fields && item.track_fields instanceof Object) {
                track_fields = item.track_fields;
              }
              if (component === 'note_common_vert_style_4') {
                biz['note_type'] = item.is_video == 1 ? '视频' : '图文'
                biz['article_id'] = item.note_id || ''
                biz['region'] = '其他'
                biz['filter_value'] = {}
              }
              const h5_exposure_object = {
                id: `goodsSet:list:${index + 1}`,
                name: '',
                href: item.href,
                pageOptions: {
                  ...pageOptions,
                  ...biz
                },
                biz: JSON.stringify({
                  ...pageOptions,
                  ...biz,
                  ...track_fields
                }),
                exposekey: `goodsSet:list:${index + 1}`,
                exposekey_self: item.expose_key || '',
              };
              return (
                <div
                  key={`list-${index + 1}`}
                  style={{
                    position: 'relative'
                  }}
                >
                  <SHCard
                    key={`list-${index + 1}-${item.goods_id}`}
                    customAttributes={this.props.customAttributes}
                    type={component}
                    isDark={false}
                    isLogin={isLogin}
                    dataSource={item}
                    h5_exposure_object={h5_exposure_object}
                    exp={this.props.exp}
                    onPress={(extraBiz = {}) => {
                      let ptiID = `goodsSet:list:${index + 1}`
                      if (isCardShowStyleList(item)) {
                        ptiID = `goodsSet:list:${index + 1}_0`
                      }
                      if (extraBiz) {
                        biz = {
                          ...biz,
                          ...extraBiz
                        }
                      }
                      const ptiOptions = {
                        ptiId: ptiID,
                        ptiName: '',
                        bizExtra: {
                          ...pageOptions,
                          ...biz
                        }
                      }
                      const options = this.getTrackData(item, index);
                      utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, -1, this.props, false, ptiOptions);
                    }}
                  />
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }
}

export default PipelineRecommend;


// WEBPACK FOOTER //
// ./components/pipeline-recommend/index.jsx